// extracted by mini-css-extract-plugin
export default {"windowIcon":"appIcons_windowIcon__nO32K"};